module.exports = __webpack_public_path__ + "media/components/sessions/registration-form/img/gauge_icon1-cb6bfef8fcc3c7464f196b17758d3d50.png";